/* eslint-disable max-len */
import React from 'react';

const Plus: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 1.25C10.4142 1.25 10.75 1.58579 10.75 2V9.25H18C18.4142 9.25 18.75 9.58579 18.75 10C18.75 10.4142 18.4142 10.75 18 10.75H10.75V18C10.75 18.4142 10.4142 18.75 10 18.75C9.58579 18.75 9.25 18.4142 9.25 18V10.75H2C1.58579 10.75 1.25 10.4142 1.25 10C1.25 9.58579 1.58579 9.25 2 9.25H9.25V2C9.25 1.58579 9.58579 1.25 10 1.25Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Plus;
